import { BreadcrumbService } from 'xng-breadcrumb';
import { BreadcrumbOptions } from '@ellf/app-common';
import { RouterService } from '@ellf/app-routing';
import { BaseDbDto } from '@ellf/common-dto';

export abstract class BaseDetailGuard<T extends BaseDbDto> {
  constructor(
    private breadcrumb: BreadcrumbService,
    protected routerService: RouterService,
  ) {}
  breadcrumbDefaultValue: BreadcrumbOptions = {
    showBreadcrumb: true,
    prop: '',
    listDescription: '',
    description: '',
  };

  protected abstract getUpdatePermission: string;
  protected abstract getCreatePermission: string;

  protected setBreadcrumb(item: T | undefined, disable: boolean) {
    if (this.breadcrumbDefaultValue.showBreadcrumb) {
      this.breadcrumb.set('@entityList', {
        skip: false,
        label: this.breadcrumbDefaultValue.listDescription,
        disable,
      });
      if (this.breadcrumbDefaultValue.prop && item) {
        this.breadcrumb.set('@entityDetail', {
          skip: false,
          label: (item as any)[this.breadcrumbDefaultValue.prop],
        });
      } else {
        this.breadcrumb.set('@entityDetail', {
          skip: false,
          label: this.breadcrumbDefaultValue.description,
        });
      }
    } else {
      this.breadcrumb.set('@entityList', {
        skip: true,
      });
      this.breadcrumb.set('@entityDetail', {
        skip: true,
      });
    }
  }
}
